<nz-card style="width:100%;" [nzBordered]="false" [nzTitle]="appTitle"
         [nzExtra]="appShowSelectColumn ? tableToolbar : ''" class="table-wrap">
  <ng-content></ng-content>
</nz-card>

<ng-template #tableToolbar>
  <div style='width: 100%; display: flex; justify-content:  space-between; align-content: center'>
    <div>
      <ng-content select="[content-selector=filterTableWrapTmpl]"></ng-content>
    </div>

    <button nz-button nzType="default"
            class="m-b-5"
            nzShape="round"
            nzPopoverTrigger="click"
            nz-popover [nzPopoverTitle]="popoverTitle" [nzPopoverContent]="contentTemplate"
            nzPopoverPlacement="bottomRight">Thiết lập cột
    </button>

  </div>
</ng-template>


<ng-template #contentTemplate>
  <div class="show-column__panel">
    <ul class="table-wrap__show-column" cdkDropList (cdkDropListDropped)="dropTableConfig($event)">
      <li cdkDrag class="flex space-between" style="padding: 4px 16px 8px 0" *ngFor="let item of tableHeaders">
        <label nz-checkbox (nzCheckedChange)="changeSignalCheck($event,item)" [nzDisabled]="item.alwaysShow"
               [(nzChecked)]="item.show"><span cdkDragHandle>{{item.title }}</span></label>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #popoverTitle>
  <p><b>Tìm kiếm cột</b></p>

  <input nz-input placeholder="Nhập tên cột..." [(ngModel)]="columnSearch" (ngModelChange)="searchColumn()" class="m-b-10"/>

  <div>
    <span class="m-t-10">
      <label nz-checkbox (nzCheckedChange)="changeAllTableTableConfigShow($event)"
             [nzIndeterminate]="allTableFieldIndeterminate" [(nzChecked)]="allTableFieldChecked">Chọn tất cả
      </label>
    </span>
    <br>
    <button (click)="reset()" class="operate-text" nz-button nzType="link">Thiết lập lại</button>
  </div>

</ng-template>
